import { render, staticRenderFns } from "./addBorrowView.vue?vue&type=template&id=f3fab1e8&scoped=true"
import script from "./addBorrowView.vue?vue&type=script&lang=js"
export * from "./addBorrowView.vue?vue&type=script&lang=js"
import style0 from "./addBorrowView.vue?vue&type=style&index=0&id=f3fab1e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3fab1e8",
  null
  
)

export default component.exports